// Vector PDF export using @react-pdf/renderer. Produces a true PDF
// (selectable text, real page breaks, ATS-parseable) instead of the
// browser print-CSS rasterized output.
//
// Only Modern is migrated for now — other templates fall back to the
// legacy window.print() path until each is reimplemented as a
// @react-pdf/renderer component.

import React from 'react';
import { pdf } from '@react-pdf/renderer';
import ModernPdf from '../pdfTemplates/ModernPdf.jsx';
import { sanitizeResumeData } from '../resumeSanitize.js';

const PDF_TEMPLATES = {
    modern: ModernPdf
    // classic, minimalist, creative, professional — TODO: port to @react-pdf/renderer
};

export const canExportVectorPdf = (template) => Boolean(PDF_TEMPLATES[template]);

export const exportVectorPdf = async (resumeData, template) => {
    const TemplateComponent = PDF_TEMPLATES[template];
    if (!TemplateComponent) {
        throw new Error(`No vector PDF template available for "${template}".`);
    }

    // Templates assume clean strings; imports and legacy saves do not guarantee
    // them. Normalising here keeps every caller of this function safe.
    const safeData = sanitizeResumeData(resumeData);

    const blob = await pdf(<TemplateComponent resumeData={safeData} />).toBlob();

    const name = safeData.personal.fullName
        ? safeData.personal.fullName.replace(/\s+/g, '_')
        : 'Resume';
    const filename = `${name}_${template.charAt(0).toUpperCase() + template.slice(1)}.pdf`;

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
};
